import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTeamsStore } from '../../store/teamsStore';
import { listScopes } from '../../extensions/bundled/documents/documentsScopes';
import { useDocumentsUiStore } from '../../extensions/bundled/documents/documentsUiStore';

/**
 * A document scope's display name: the workspace, the team, This device or
 * Personal — the breadcrumb's first segment and the folder chip's prefix
 * (cards 2.1 / 5.3).
 */
export default function useScopeName(scope) {
  const { t } = useTranslation();
  const teamName = useTeamsStore((s) =>
    scope?.type === 'team' ? (s.teams || []).find((x) => String(x?.id) === String(scope.teamId))?.name : null
  );
  // `{ id, name }` so a re-read after a tree bump never flashes "Personal":
  // the old name stays until the new one lands, and only for its own id.
  const [found, setFound] = useState(null);
  // A rename in Manage workspaces bumps the tree; the name follows.
  const treeVersion = useDocumentsUiStore((s) => s.treeVersion);
  const scopeId = scope?.type === 'personal' || !scope?.type ? scope?.scopeId || null : null;
  useEffect(() => {
    let cancelled = false;
    if (!scopeId) return undefined;
    listScopes()
      .then((list) => {
        if (!cancelled) setFound({ id: scopeId, name: (list || []).find((s) => s.id === scopeId)?.name || null });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [scopeId, treeVersion]);
  const workspaceName = scopeId && found?.id === scopeId ? found.name : null;
  if (scope?.type === 'team') return teamName || t('docEditor.scope.team');
  if (scope?.type === 'device') return t('docEditor.scope.device');
  return workspaceName || t('docEditor.scope.personal');
}

